<template>
  <admin-page-frame>
    <school-list-toolbar @search="loadList" @reset="handleReset">
      <template #actions><el-button class="filter-item" type="primary" size="mini" icon="el-icon-plus" @click="openForm()">新增</el-button></template>
      <template #filters>
        <el-input v-model="query.keyword" clearable size="small" placeholder="姓名/学号/家长手机" class="filter-item" style="width: 220px; margin-right: 10px;" @keyup.enter.native="loadList" />
        <el-select v-model="query.gender" clearable size="small" placeholder="性别" class="filter-item" style="width: 110px; margin-right: 10px;">
          <el-option label="未知" :value="0" /><el-option label="男" :value="1" /><el-option label="女" :value="2" />
        </el-select>
        <el-select v-model="query.status" clearable size="small" placeholder="状态" class="filter-item" style="width: 120px; margin-right: 10px;">
          <el-option label="正常" :value="1" /><el-option label="停用" :value="0" />
        </el-select>
      </template>
    </school-list-toolbar>
    <el-table v-loading="loading" :data="list" :border="false" size="small" style="width: 100%;">
      <el-table-column label="图片" width="72" align="center">
        <template slot-scope="{ row }">
          <img v-if="firstImage(row)" :src="toFullUrl(firstImage(row))" style="width: 44px; height: 44px; object-fit: cover; border-radius: 4px;">
          <span v-else style="color:#c0c4cc;">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="studentCode" label="学号" min-width="120" show-overflow-tooltip />
      <el-table-column prop="studentName" label="学员姓名" min-width="100" show-overflow-tooltip />
      <el-table-column label="性别" width="70" align="center"><template slot-scope="{ row }">{{ genderLabel(row.gender) }}</template></el-table-column>
      <el-table-column prop="parentPhone" label="家长手机" min-width="120" />
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="80" align="center"><template slot-scope="{ row }"><el-tag :type="row.status === 1 ? 'success' : 'info'" size="mini">{{ row.status === 1 ? '正常' : '停用' }}</el-tag></template></el-table-column>
      <el-table-column label="操作" min-width="140" width="140" align="center" fixed="right" class-name="admin-pc-table-actions-col">
        <template slot-scope="{ row }"><div class="admin-pc-table-actions"><el-button type="text" size="mini" @click="goDetail(row)">详情</el-button><el-button type="text" size="mini" @click="openForm(row)">编辑</el-button></div></template>
      </el-table-column>
    </el-table>
    <school-list-pagination :total="total" :page="query.page" :size="query.size" @page-change="onPageChange" @size-change="onSizeChange" />
    <el-dialog :title="form.id ? '编辑学员' : '新增学员'" :visible.sync="formVisible" width="560px" :close-on-click-modal="false" @closed="resetForm">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="90px" size="small" class="admin-pc-dialog-form">
        <el-form-item v-if="form.id" label="学号">
          <el-input v-model="form.studentCode" disabled />
        </el-form-item>
        <p v-else class="admin-pc-form-hint">学号将在保存后自动生成</p>
        <el-form-item label="学员姓名" prop="studentName"><el-input v-model="form.studentName" maxlength="64" /></el-form-item>
        <el-form-item label="性别"><el-radio-group v-model="form.gender"><el-radio :label="0">未知</el-radio><el-radio :label="1">男</el-radio><el-radio :label="2">女</el-radio></el-radio-group></el-form-item>
        <el-form-item label="家长手机" prop="parentPhone"><el-input v-model="form.parentPhone" maxlength="20" /></el-form-item>
        <el-form-item label="图片">
          <admin-multi-image-upload v-model="form.imageUrls" :limit="9" />
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="3" maxlength="512" /></el-form-item>
        <el-form-item label="状态"><el-radio-group v-model="form.status"><el-radio :label="1">正常</el-radio><el-radio :label="0">停用</el-radio></el-radio-group></el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer"><el-button size="small" @click="formVisible = false">取消</el-button><el-button type="primary" size="small" :loading="saving" @click="submitForm">保存</el-button></div>
    </el-dialog>
  </admin-page-frame>
</template>
<script>
import AdminPageFrame from './components/AdminPageFrame.vue'
import SchoolListToolbar from './components/SchoolListToolbar.vue'
import SchoolListPagination from './components/SchoolListPagination.vue'
import AdminMultiImageUpload from '../../admin/components/AdminMultiImageUpload.vue'
import schoolListPageMixin from './mixins/school-list-page'
import { fetchSchoolStudents, saveSchoolStudent, updateSchoolStudent } from '@/api/h5-admin-schools'
import './schools-admin.less'

const DEFAULT_QUERY = { keyword: '', gender: null, status: null, page: 0, size: 20 }

function emptyForm() {
  return { id: null, studentCode: '', studentName: '', gender: 0, parentPhone: '', imageUrls: [], remark: '', status: 1 }
}

export default {
  name: 'SchoolsStudent',
  components: { AdminPageFrame, SchoolListToolbar, SchoolListPagination, AdminMultiImageUpload },
  mixins: [schoolListPageMixin],
  data() {
    return {
      loading: false, saving: false, list: [], total: 0, query: { ...DEFAULT_QUERY }, formVisible: false,
      form: emptyForm(),
      formRules: { studentName: [{ required: true, message: '请输入学员姓名', trigger: 'blur' }] }
    }
  },
  created() { this.loadList() },
  methods: {
    handleReset() { this.resetListQuery(DEFAULT_QUERY) },
    genderLabel(v) { const map = { 0: '未知', 1: '男', 2: '女' }; return map[v] || '-' },
    firstImage(row) { return (row.imageUrls && row.imageUrls[0]) || '' },
    toFullUrl(raw) {
      const v = String(raw == null ? '' : raw).trim()
      if (!v) return ''
      if (/^https?:\/\//i.test(v)) return v
      if (v.startsWith('/')) return (process.env.NODE_ENV === 'development' ? window.location.origin : 'https://wvxvb.cn') + v
      return 'https://wvxvb.cn/upload/' + v.replace(/^\/+/, '')
    },
    applyClientFilters(rows) {
      let list = rows || []
      if (this.query.gender != null && this.query.gender !== '') list = list.filter(r => r.gender === this.query.gender)
      if (this.query.status != null && this.query.status !== '') list = list.filter(r => r.status === this.query.status)
      return list
    },
    loadList() {
      this.loading = true
      const hasClientFilter = (this.query.gender != null && this.query.gender !== '') || (this.query.status != null && this.query.status !== '')
      const params = { keyword: this.query.keyword || undefined, page: hasClientFilter ? 0 : this.query.page, size: hasClientFilter ? 500 : this.query.size }
      fetchSchoolStudents(params).then(res => {
        let list = (res && res.content) || []
        list = this.applyClientFilters(list)
        if (hasClientFilter) { this.total = list.length; const start = this.query.page * this.query.size; list = list.slice(start, start + this.query.size) }
        else { this.total = (res && res.totalElements) || 0 }
        this.list = list
      }).finally(() => { this.loading = false })
    },
    goDetail(row) { this.$router.push('/admin/schools/student/' + row.id) },
    openForm(row) {
      if (row) {
        this.form = {
          id: row.id, studentCode: row.studentCode, studentName: row.studentName,
          gender: row.gender != null ? row.gender : 0, parentPhone: row.parentPhone || '',
          imageUrls: Array.isArray(row.imageUrls) ? [...row.imageUrls] : [],
          remark: row.remark || '', status: row.status != null ? row.status : 1
        }
      } else { this.resetForm() }
      this.formVisible = true
    },
    resetForm() { this.form = emptyForm(); this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate()) },
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.saving = true
        const req = this.form.id ? updateSchoolStudent(this.form.id, this.form) : saveSchoolStudent(this.form)
        req.then(() => { this.$message.success('保存成功'); this.formVisible = false; this.loadList() }).finally(() => { this.saving = false })
      })
    }
  }
}
</script>
